import { Draggable } from '@shopify/draggable'

/* @ngInject */
function RepositoryScreenSectionsController ($scope, $stateParams, $rootScope, $timeout, $translate, Utils, AssetPreviewService, NewAssetService, RepositoryService, UdsModalService, ToastService, SegmentService, MimeService) {
  const getMoveToTrashDialogController = () => import('../../dialogs/move-to-trash/move-to-trash-dialog.controller')
  const getOrganizeAssetDialogController = () => import('../../dialogs/organize-asset/organize-asset-dialog.controller')

  $scope.orderIcon = $scope.pagination?.$order === 'DESC' ? 'arrow-down' : 'arrow-up'
  $scope.assetsSort = $scope.pagination?.$sort
  $scope.assetsOrder = $scope.pagination?.$order

  $scope.assetsSortOptions = [
    {
      label: $translate.instant('repository.assetsSortOptions.relevance'),
      value: 'relevance',
      active: $scope.pagination?.$sort === 'relevance'
    },
    {
      label: $translate.instant('repository.assetsSortOptions.name'),
      value: 'name',
      active: $scope.pagination?.$sort === 'name'
    },
    {
      label: $translate.instant('repository.assetsSortOptions.size'),
      value: 'size',
      active: $scope.pagination?.$sort === 'size'
    },
    {
      label: $translate.instant('repository.assetsSortOptions.latestUpdates'),
      value: 'latestUpdates',
      active: $scope.pagination?.$sort === 'latestUpdates'
    }
  ]

  const api = {
    getMoveToTrashDialogController,
    getOrganizeAssetDialogController,
    _getTooltipTextForExtensions,
    _getContentTypesForExtensions,
    _openMoveToTrashDialog,
    _openRestoreAssetDialog,
    _removeAssetsFromList,
    _shouldOpenPreviewOnLoadPage,
    _initializeDraggable,
    _handleDraggableOn,
    _handleDraggableOff,
    _initializeHoverLogger,
    _handleMoveMultipleAssets,
    _shouldMoveCards,
    _draggingAssetCard,
    _draggingAssetFolder,
    _draggingOffAssetCard,
    _draggingOffAssetFolder,
    _handleMoveMultipleFolders
  }

  this.getApi = () => api

  const allowedAssetContentTypes = api._getContentTypesForExtensions($scope.allowedAssetExtensionsSelection)
  $scope.assetTypeTooltipText = api._getTooltipTextForExtensions($scope.allowedAssetExtensionsSelection)

  function activate () {
    api._shouldOpenPreviewOnLoadPage()
    $scope.visualization = $stateParams.view || 'grid'
    api._initializeDraggable()
    api._initializeHoverLogger()
    $scope.isOrganized = api._shouldMoveCards()
  }

  activate()

  $scope.handleOpenFolder = (folder) => {
    $scope.openFolder({ folder })
  }

  $scope.handleGoBackFolder = () => {
    $scope.goBackFolder()
  }

  $scope.shouldShowGoBackFolderButton = (section) => {
    if (!$scope.modalState) return false
    if ($scope.currentPage !== 'organized') return false

    const folderSection = $scope.sections[0]
    const sectionHasFolders = folderSection.assets.length

    if (section.slug !== 'folders' && sectionHasFolders) return false

    const isShowingRoot = sectionHasFolders && !folderSection.assets?.[0]?.parentId

    return !isShowingRoot
  }

  const deregisterSelectedAssets = $scope.$on('asset-card.update-selected-assets', (event, selectedAssets) => {
    $scope.selectedAssets = selectedAssets
  })

  $scope.$on('$destroy', () => {
    deregisterSelectedAssets()
  })

  function _initializeDraggable () {
    $timeout(() => {
      const containers = document.querySelectorAll('.cards-container.grid')
      if (containers.length) {
        containers.forEach(container => {
          const draggable = new Draggable(container, {
            draggable: '.asset-card, .asset-folder',
            handle: '.asset-card-content-draggable, .asset-folder-content-draggable',
            mirror: {
              appendTo: 'body',
              constrainDimensions: true
            }
          })

          draggable.on('drag:start', api._handleDraggableOn)
          draggable.on('drag:stop', api._handleDraggableOff)
          draggable.on('mirror:created', function (evt) {
            if (evt.source.classList[0] === 'asset-card') {
              const mirror = evt.data.mirror
              const count = $scope.draggedAssetIds.length
              mirror.querySelector('.wrapper-asset-card').style.opacity = '1'
              mirror.classList.add('asset-card-mirror')
              if (count > 1) {
                mirror.classList.add('mirror-with-counter')
                mirror.setAttribute('data-count', count)
              }
            } else {
              const mirror = evt.data.mirror
              const count = $scope.draggedFolderIds.length
              mirror.querySelector('.wrapper-asset-folder').style.opacity = '1'
              mirror.querySelector('.wrapper-asset-folder').style.height = '52px'
              if (count > 1) {
                mirror.classList.add('mirror-with-counter')
                mirror.setAttribute('data-count', count)
              }
            }
          })
        })
      }
    }, 0)
  }

  function _handleDraggableOn (event) {
    if (event.source.classList[0] === 'asset-card') {
      api._draggingAssetCard(event)
    } else {
      api._draggingAssetFolder(event)
    }
  }

  function _handleDraggableOff (event) {
    if (event.source.classList[0] === 'asset-card') {
      api._draggingOffAssetCard(event)
    } else {
      api._draggingOffAssetFolder(event)
    }
  }

  function _draggingAssetCard (event) {
    const selectedCards = document.querySelectorAll('.asset-card.selected')

    if (selectedCards.length) {
      selectedCards.forEach(card => {
        card.children[0].style.opacity = '0.3'
        card.children[0].style.height = '56px'
      })
    } else {
      event.data.source.children[0].style.opacity = '0.3'
      event.data.source.children[0].style.height = '56px'
    }

    if (selectedCards.length > 1) {
      $scope.draggedAssetIds = Array.from(selectedCards).reduce((ids, card) => {
        const cardId = card.getAttribute('data-id')
        if (!ids.includes(cardId)) {
          ids.push(cardId)
        }
        return ids
      }, [])
    } else {
      const draggedCardId = event.data.source.dataset.id
      if (draggedCardId) {
        $scope.draggedAssetIds = [draggedCardId]
      }
    }
  }

  function _draggingOffAssetCard (event) {
    const selectedCards = document.querySelectorAll('.asset-card.selected')

    if (selectedCards.length) {
      selectedCards.forEach(card => {
        card.children[0].style.opacity = '1'
      })
    } else {
      event.data.source.children[0].style.opacity = '1'
    }

    if ($scope.draggedAssetIds && $scope.currentDropTargetFolderId) {
      api._handleMoveMultipleAssets($scope.draggedAssetIds, $scope.currentDropTargetFolderId)
    }
    $scope.draggedAssetIds = null
    $scope.currentDropTargetFolderId = null
    event._canceled = true
  }

  function _draggingAssetFolder (event) {
    const selectedFolders = document.querySelectorAll('.asset-folder.selected')

    if (selectedFolders.length) {
      selectedFolders.forEach(folder => {
        folder.children[0].style.opacity = '0.3'
      })
    } else {
      event.data.source.children[0].style.opacity = '0.3'
    }

    if (selectedFolders.length > 1) {
      $scope.draggedFolderIds = Array.from(selectedFolders).reduce((ids, folder) => {
        const folderId = folder.getAttribute('data-id')
        if (!ids.includes(folderId)) {
          ids.push(folderId)
        }
        return ids
      }, [])
    } else {
      const draggedFolderId = event.data.source.dataset.id
      if (draggedFolderId) {
        $scope.draggedFolderIds = [draggedFolderId]
      }
    }
  }

  function _draggingOffAssetFolder (event) {
    const selectedFolders = document.querySelectorAll('.asset-folder.selected')

    if (selectedFolders.length) {
      selectedFolders.forEach(card => {
        card.children[0].style.opacity = '1'
      })
    } else {
      event.data.source.children[0].style.opacity = '1'
    }

    if (
      $scope.draggedFolderIds &&
        $scope.currentDropTargetFolderId &&
        !$scope.draggedFolderIds.includes($scope.currentDropTargetFolderId)
    ) {
      api._handleMoveMultipleFolders($scope.draggedFolderIds, $scope.currentDropTargetFolderId)
    }
    $scope.draggedFolderIds = null
    $scope.currentDropTargetFolderId = null
    event._canceled = true
  }

  function _handleMoveMultipleAssets (assets, folderId) {
    const assetsId = assets.map((id) => id)

    if (assetsId && folderId) {
      RepositoryService.moveMultipleAssets({ assetsId, folderId }).then(() => {
        if (assetsId.length > 1) {
          ToastService.showSuccessToast($translate.instant('moveAssetsToFolder.toast.successMultiple'))
        } else {
          ToastService.showSuccessToast($translate.instant('moveAssetsToFolder.toast.successSingular'))
        }
        for (const assetId of assetsId) {
          $scope.sections[1].assets = $scope.sections[1].assets.filter(asset => asset.id !== parseInt(assetId))
        }
        SegmentService.track('file-organize', {
          organize_action: 'drag-and-drop'
        })
      }).catch(error => {
        ToastService.showErrorToast($translate.instant('moveAssetsToFolder.toast.error'))
        console.error(error)
      })
    }
  }

  function _handleMoveMultipleFolders (folders, targetFolderId) {
    const folderIds = folders.map((id) => id)

    if (folderIds && targetFolderId) {
      RepositoryService.moveMultipleFolders({ folderIds, targetFolderId }).then(() => {
        if (folderIds.length > 1) {
          ToastService.showSuccessToast($translate.instant('moveFoldersToFolder.toast.successMultiple'))
        } else {
          ToastService.showSuccessToast($translate.instant('moveFoldersToFolder.toast.successSingular'))
        }
        for (const folderId of folderIds) {
          $scope.sections[0].assets = $scope.sections[0].assets.filter(asset => asset.id !== parseInt(folderId))
        }
        $rootScope.$emit('folders-assets.deselect')
      }).catch(error => {
        ToastService.showErrorToast($translate.instant('moveFoldersToFolder.toast.error'))
        console.error(error)
      })
    }
  }

  function _initializeHoverLogger () {
    $timeout(() => {
      const folders = document.querySelectorAll('asset-folder')
      folders.forEach(folder => {
        folder.addEventListener('mouseenter', () => {
          $scope.currentDropTargetFolderId = folder.getAttribute('data-id')
          if (
            ($scope.draggedAssetIds?.length && $scope.currentDropTargetFolderId) ||
              (
                $scope.draggedFolderIds?.length && $scope.currentDropTargetFolderId &&
                !$scope.draggedFolderIds.includes($scope.currentDropTargetFolderId)
              )
          ) {
            folder.children[0].style.border = '2px dashed #0d94ff'
            folder.children[0].style.borderRadius = '8px'
            folder.children[0].style.transition = '200ms all ease-in-out'
            folder.children[0].style.transform = 'scale(1.03)'
          }
        })

        folder.addEventListener('mouseleave', () => {
          $scope.currentDropTargetFolderId = null
          folder.children[0].style.border = null
          folder.children[0].style.transform = null
          folder.children[0].style.transition = null
        })
      })
    }, 1000)
  }

  function _shouldMoveCards () {
    if ($scope.modalState || $scope.currentPage === 'trash') {
      return false
    }

    return $scope.sections.some(section => section.slug === 'folders')
  }

  function _shouldOpenPreviewOnLoadPage () {
    const previewId = Array.isArray($stateParams.previewId) ? $stateParams.previewId[0] : $stateParams.previewId
    const folderPreviewId = Array.isArray($stateParams.folderPreviewId) ? $stateParams.folderPreviewId[0] : $stateParams.folderPreviewId

    if (!previewId && !folderPreviewId) {
      return
    }

    if (folderPreviewId) {
      RepositoryService.getFolderById(folderPreviewId).then((folder) => {
        $scope.openPreview(folder, null, 0)
      })
    } else {
      NewAssetService.getAssetDetails(previewId).then((asset) => {
        $scope.openPreview(asset, null, 0)
      })
    }
  }

  function _getContentTypesForExtensions (allowedAssetExtensions) {
    if (!allowedAssetExtensions?.length) {
      return []
    }

    const allowedTypes = allowedAssetExtensions
      .map(extension => extension === 'deskfy' ? 'application/json' : MimeService.getType(extension))
      .join(', ')

    return allowedTypes
  }

  function _getTooltipTextForExtensions (allowedAssetExtensions) {
    if (!allowedAssetExtensions?.length) {
      return ''
    }

    const assetExtensions = allowedAssetExtensions.reduce((str, extension) => {
      str += str ? `, ${extension.toUpperCase()}` : `${extension.toUpperCase()}`

      return str
    }, '')

    return $translate.instant('repository.assetCard.disabledTooltip', { assetExtensions })
  }

  $scope.shouldShowSection = (section) => {
    return section.assets.length > 0
  }

  $scope.openPreview = async (asset, section, assetIndex) => {
    if (AssetPreviewService.assetPreviewIsOpen()) {
      return
    }

    if (!asset.assetId) {
      asset.isFolder = true
      localStorage.setItem('isFolder', true)
    }

    AssetPreviewService.openAssetPreview({
      asset: asset,
      location: asset.assetId ? 'repository' : 'repositoryFolder',
      getPreviewAssets: () => {
        return Promise.resolve({
          assets: section?.assets || [],
          count: section?.assets?.length || 0
        })
      },
      onDeleteAsset: (asset) => {
        api._openMoveToTrashDialog(asset, section, assetIndex)
      },
      onRestoreAsset: (asset) => {
        api._openRestoreAssetDialog(asset, section, assetIndex)
      }
    })
  }

  function _openMoveToTrashDialog (asset, section, assetIndex) {
    api.getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const nameDisplayLength = 32
      const assets = [{
        id: asset.id,
        assetSize: Utils.getReadableFileSizeString(asset.size),
        assetName: RepositoryService.defineFullAssetNameToDisplay(asset, nameDisplayLength),
        assetIcon: RepositoryService.defineAssetIconBasedOnExtension(asset)
      }]

      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets
        },
        onClose: hasMoved => {
          if (hasMoved) {
            api._removeAssetsFromList(section, assetIndex)
            AssetPreviewService.closePreview()
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  function _openRestoreAssetDialog (asset, section, assetIndex) {
    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const nameDisplayLength = 32
      const assets = [{
        id: asset.id,
        assetName: RepositoryService.defineFullAssetNameToDisplay(asset, nameDisplayLength)
      }]

      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets,
          isRestoring: true,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            api._removeAssetsFromList(section, assetIndex)
            AssetPreviewService.closePreview()
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  function _removeAssetsFromList (section, assetIndex) {
    $timeout(() => {
      section.assets.splice(assetIndex, 1) // remove asset from list
      section.totalCount--
    })
  }

  $scope.isAssetCardDisabled = (asset) => {
    if (!allowedAssetContentTypes?.length) {
      return false
    }

    const isSingleAttach = RepositoryService.isSingleAttach($scope.singleAttach, $scope.selectedAssets, asset)
    const isNotAllowedContentType = !allowedAssetContentTypes.includes(asset.contentType)

    return isNotAllowedContentType || isSingleAttach
  }

  $scope.orderToggle = () => {
    if ($scope.pagination?.$order === 'DESC') {
      $scope.orderIcon = 'arrow-up'
      $scope.assetsOrder = 'ASC'
    } else {
      $scope.orderIcon = 'arrow-down'
      $scope.assetsOrder = 'DESC'
    }

    $rootScope.$emit('select-assets-sort-order', {
      sort: $scope.assetsSort,
      order: $scope.assetsOrder
    })
  }

  $scope.onChangeSortSelect = event => {
    event.preventDefault()
    event.stopPropagation()
    const value = event?.detail?.value

    if (value) {
      $scope.assetsSort = value

      $rootScope.$emit('select-assets-sort-order', {
        sort: $scope.assetsSort,
        order: $scope.assetsOrder
      })
    }
  }

  $scope.changeVisualization = (value) => {
    if ($scope.visualization === value) {
      return
    }
    $scope.visualization = value
    RepositoryService.setView(value)
  }
}

export { RepositoryScreenSectionsController }
